export default __webpack_public_path__ + "assets/3db45d2d266f0b84e741fe5ddaae2d65.jpg";